/**! Qoopido.demand 5.2.0-rc.6 | https://github.com/dlueth/qoopido.demand | (c) 2018 Dirk Lueth */
(function () {
	"use strict";

	function definition(abstractHandler) {
		function HandlerJson() {}
		var suffix = ".json",
			regexMatchType = /^application\/json/;
		HandlerJson.prototype = {
			validate: function (type) {
				return regexMatchType.test(type)
			},
			onPreRequest: function (dependency) {
				var pathname = dependency.url.pathname;
				dependency.url.pathname = pathname.slice(-suffix.length) !== suffix ? pathname + suffix : pathname
			},
			process: function (dependency) {
				var data = JSON.parse(dependency.source);
				provide(function () {
					return data
				})
			}
		};
		return new(HandlerJson.extends(abstractHandler))
	}
	provide(["/demand/abstract/handler"], definition)
})();
